<div class="main-wrapper">
  <div class="health-container">
    <input class="radio" id="one" name="group" type="radio" checked />
    <input class="radio" id="two" name="group" type="radio" />
    <input class="radio" id="three" name="group" type="radio" />

    <div class="tabs">
      <label class="tab" id="one-tab" for="one" (click)="selectTab(1)"
        >Overview</label
      >
      <label class="tab" id="two-tab" for="two" (click)="selectTab(2)"
        >Details</label
      >
      <label class="tab" id="three-tab" for="three" (click)="selectTab(3)"
        >Graph</label
      >
    </div>
    <div class="panels">
      <div
        [class]="[currentTab == 1 ? 'panel' : 'panel active']"
        id="one-panel"
      >
        <!-- <div class="panel-container">
        <img src="../../assets/health-overview-bg.PNG" />
      </div> -->
        <div class="panel-content">
          <div class="health-img-container1">
            <img
              src="../../assets/health-overview-bg1.PNG"
              *ngIf="currentTab == 1"
            />
          </div>
          <div class="health-img-container2" *ngIf="mainFaultType == 0">
            <img
              src="../../assets/liner-health-g.svg"
              *ngIf="currentTab == 1"
            />
          </div>
          <div class="health-img-container2" *ngIf="mainFaultType == 1">
            <img
              src="../../assets/liner-health-y.svg"
              *ngIf="currentTab == 1"
            />
          </div>
          <div class="health-img-container2" *ngIf="mainFaultType == 2">
            <img
              src="../../assets/liner-health-r.svg"
              *ngIf="currentTab == 1"
            />
          </div>
          <div class="health-img-container3" *ngIf="cmsFaultType == 0">
            <img src="../../assets/arc.svg" *ngIf="currentTab == 1" />
          </div>
          <div class="health-img-container3" *ngIf="cmsFaultType == 1">
            <img src="../../assets/arc-y.svg" *ngIf="currentTab == 1" />
          </div>
          <div class="health-img-container3" *ngIf="cmsFaultType == 2">
            <img src="../../assets/arc-r.svg" *ngIf="currentTab == 1" />
          </div>
        </div>
      </div>
      <div
        [class]="[currentTab == 2 ? 'panel' : 'panel active']"
        id="two-panel"
      >
        <div class="panel-content">
          <div class="fault-section" *ngIf="currentTab == 2">
            <div class="fault-header">CMS</div>
            <table class="fault-table">
              <colgroup>
                <col span="1" style="width: 20px" />
                <col span="1" style="width: 10%" />
                <col span="1" style="width: 10%" />
                <col span="1" style="width: 80%" />
              </colgroup>
              <tr *ngFor="let u of FD">
                <td>
                  <div
                    class="statusDot"
                    [ngStyle]="{
                      'background-color': getFaultStatusColor(u.FT)
                    }"
                  ></div>
                </td>
                <td>
                  {{ calculateDistance(u.P, u.SI) | number : "1.2-2"
                  }}<span *ngIf="projectService.isMetricUnit">m</span
                  ><span *ngIf="!projectService.isMetricUnit">ft</span>
                </td>
                <td>{{ u.V | number : "1.2-2" }} dB</td>
                <td>{{ u.D }}</td>
              </tr>
              <!-- <tr *ngFor="let item of [0, 1, 2, 3, 4]; let i = index">
              <td>{{ item }}</td>
              <td>0,00dB</td>
              <td>OK</td>
            </tr> -->
            </table>
          </div>
          <div class="fault-section" *ngIf="currentTab == 2">
            <div class="fault-header">Precarriage</div>
            <table class="fault-table">
              <colgroup>
                <col span="1" style="width: 20px" />
                <col span="1" style="width: 10%" />
                <col span="1" style="width: 10%" />
                <col span="1" style="width: 80%" />
              </colgroup>
              <tr *ngFor="let u of FP">
                <td>
                  <div
                    class="statusDot"
                    [ngStyle]="{
                      'background-color': getFaultStatusColor(u.FT)
                    }"
                  ></div>
                </td>
                <td>
                  {{ calculateDistance(u.P, u.SI) | number : "1.2-2"
                  }}<span *ngIf="projectService.isMetricUnit">m</span
                  ><span *ngIf="!projectService.isMetricUnit">ft</span>
                </td>
                <td>{{ u.V | number : "1.2-2" }} dB</td>
                <td>{{ u.D }}</td>
              </tr>
              <!-- <tr *ngFor="let item of [0, 1, 2, 3, 4]; let i = index">
              <td>{{ item }}</td>
              <td>0,00dB</td>
              <td>OK</td>
            </tr> -->
            </table>
          </div>
          <div class="fault-section" *ngIf="currentTab == 2">
            <div class="fault-header">Main</div>
            <table class="fault-table">
              <colgroup>
                <col span="1" style="width: 20px" />
                <col span="1" style="width: 10%" />
                <col span="1" style="width: 10%" />
                <col span="1" style="width: 80%" />
              </colgroup>
              <tr *ngFor="let u of FM">
                <td>
                  <div
                    class="statusDot"
                    [ngStyle]="{
                      'background-color': getFaultStatusColor(u.FT)
                    }"
                  ></div>
                </td>
                <td>
                  {{ calculateDistance(u.P, u.SI) | number : "1.2-2"
                  }}<span *ngIf="projectService.isMetricUnit">m</span
                  ><span *ngIf="!projectService.isMetricUnit">ft</span>
                </td>
                <td>{{ u.V | number : "1.2-2" }} dB</td>
                <td>{{ u.D }}</td>
              </tr>
              <!-- <tr *ngFor="let item of [0, 1, 2, 3, 4]; let i = index">
              <td>{{ item }}</td>
              <td>0,00dB</td>
              <td>OK</td>
            </tr> -->
            </table>
          </div>
        </div>
      </div>
      <div
        [class]="[currentTab == 3 ? 'panel' : 'panel active']"
        id="three-panel"
      >
        <div class="panel-content">
          <div id="loss-graph"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="chart-controls" *ngIf="currentTab == 3">
  <div class="controls-top">
    <div class="help-btn" (click)="toggleHelpOverlay()">
      <img src="../../assets/Help/Help.svg" alt="" class="help-btn-img" />
    </div>
    <ul>
      <li
        (click)="setRollOver(true)"
        [class]="[rolloverModifier?.isEnabled ? 'highlighted' : '']"
      >
        <a [routerLink]="" class="link1"></a>
        <img
          src="../../assets/Help/Inspect.svg"
          class="help-right"
          *ngIf="this.projectService.isHelpOverlayVisible"
        />
      </li>
      <li
        (click)="setPan(true)"
        [class]="[zoomPanModifier?.isEnabled ? 'highlighted' : '']"
      >
        <a [routerLink]="" class="link2"></a>
        <img
          src="../../assets/Help/Drag.svg"
          class="help-right"
          *ngIf="this.projectService.isHelpOverlayVisible"
        />
      </li>
      <li
        (click)="setZoom(true)"
        [class]="[rubberBandZoomModifier?.isEnabled ? 'highlighted' : '']"
      >
        <a [routerLink]="" class="link3"></a>
        <img
          src="../../assets/Help/Zoom.svg"
          class="help-right"
          *ngIf="this.projectService.isHelpOverlayVisible"
        />
      </li>
    </ul>
  </div>
  <div class="controls-top">
    <ul>
      <li (click)="zoomOut()">
        <a [routerLink]="" class="link4"></a>
        <img
          src="../../assets/Help/Zoom out.svg"
          class="help-right"
          *ngIf="this.projectService.isHelpOverlayVisible"
        />
      </li>
      <li>
        <a [routerLink]="" class="link5"></a>
        <img
          src="../../assets/Help/Show Hide Zoom Control.svg"
          class="help-right"
          *ngIf="this.projectService.isHelpOverlayVisible"
        />
      </li>
    </ul>
  </div>
  <div class="controls-spacer"></div>
  <div class="controls-bottom">
    <ul>
      <li (click)="addMarker()">
        <a [routerLink]="" class="link6"></a>
        <img
          src="../../assets/Help/Add Marker .svg"
          class="help-right"
          *ngIf="this.projectService.isHelpOverlayVisible"
        />
      </li>
      <li>
        <a [routerLink]="" class="link7"></a>
      </li>
    </ul>
  </div>
</div>
